import React, { useEffect, useContext } from "react"
import PrimaryButton from "../Button/PrimaryButton"
import DefaultButton from "../Button/DefaultButton"
import { Context } from "../context"

const QuotePopUpButton = ({text, iconAfter, icon, thanksURL, size, btnStyle}) => {
    const {popupContext, setPopupContext} = useContext(Context);
    const HandleModalOpen = () => {
      setPopupContext({
        isVisible: true,
        thanksURL: thanksURL
      })
    }
    useEffect(() => {
        if (popupContext.isVisible===true) {
            document.querySelector("body").classList.add("modal-open")
        } else {
            document.querySelector("body").classList.remove("modal-open")
        }
    }, [popupContext, setPopupContext])
    
    return(
        <>
            {btnStyle ? (
                
                    <button type="button" aria-label="button" aria-hidden="true" onClick={HandleModalOpen}><PrimaryButton text={text} iconAfter={iconAfter} icon={icon} size={size} /></button>
                    
                ) : (
                    <button type="button" aria-label="button" aria-hidden="true" onClick={HandleModalOpen}><DefaultButton text={text} iconAfter={iconAfter} icon={icon} size={size} /></button>
            
                )
            }
        </>

    )
}

export default QuotePopUpButton